<script setup lang="ts">
import { useI18n } from 'vue-i18n';

import Icon from '@/components/atoms/Icon.vue';

defineProps({
  active: {
    type: Boolean,
    default: false,
  },
  busy: {
    type: Boolean,
    default: false,
  },
  ready: {
    type: Boolean,
    default: false,
  },
});

const { t } = useI18n();
</script>

<template>
  <q-btn
    flat
    round
    class="scout-button"
    :class="{ 'scout-button--active': active }"
    size="12px"
    :aria-label="active ? t('Minimize Scout') : t('Open Scout')"
    :aria-pressed="active"
  >
    <Icon icon-folder="scout" icon-name="scout_chat" icon-size="20px" />
    <span
      v-if="busy || ready"
      class="scout-button__activity bg-agent"
      :class="{ 'scout-button__activity--busy': busy }"
    />
    <q-tooltip anchor="top middle" self="center middle">
      {{ active ? t('Minimize Scout') : t('Open Scout') }}
    </q-tooltip>
  </q-btn>
</template>

<style scoped lang="scss">
.scout-button {
  border: 1px solid $secondary-200;
  border-radius: 50%;
  transition:
    border-color 0.15s ease,
    background-color 0.15s ease;

  &:hover {
    background-color: $secondary-50;
  }

  &--active,
  &--active:hover {
    border-color: $agent-accent;
    background-color: $secondary-50;
  }

  .scout-button__activity {
    position: absolute;
    top: 2px;
    right: 2px;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    border: 1.5px solid $white;
    pointer-events: none;
  }

  .scout-button__activity--busy {
    animation: scout-pulse 1.2s ease-in-out infinite;
  }
}

@keyframes scout-pulse {
  0%,
  100% {
    transform: scale(1);
    opacity: 1;
  }

  50% {
    transform: scale(1.5);
    opacity: 0.6;
  }
}

@media (prefers-reduced-motion: reduce) {
  .scout-button__activity--busy {
    animation: none;
  }
}
</style>
